import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { hexToRgba } from '@/utils/hexToRgba'
import { ComponentType, FC, ReactNode } from 'react'
import { Pressable, StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface IconCardProps {
    title: string
    subtitle?: string
    Icon: ComponentType<SvgProps>
    rounded?: boolean
    onPress?: () => void
    RightContent?: ReactNode
    style?: StyleProp<ViewStyle>
}

const IconCard: FC<IconCardProps> = ({
    title,
    subtitle,
    Icon,
    rounded,
    onPress,
    RightContent,
    style,
}) => {
    return (
        <Pressable
            onPress={onPress}
            style={({ hovered, pressed }) => [
                styles.container,
                rounded && styles.containerRounded,
                onPress && hovered && styles.hoveredContainer,
                onPress && pressed && styles.pressedContainer,
                style,
            ]}
        >
            <View style={styles.iconContainer}>
                <Icon />
            </View>
            <View style={styles.textContent}>
                <Text style={styles.title}>{title}</Text>
                {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
            </View>
            {RightContent}
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        borderBottomColor: hexToRgba(ColorEnum.WHITE, 0.33),
        borderBottomWidth: 1,
        flexDirection: 'row',
        alignItems: 'center',
        height: 60,
        width: 264,
        padding: 8,
        gap: 8,
    },
    textContent: {
        flex: 1,
    },
    containerRounded: {
        backgroundColor: hexToRgba(ColorEnum.WHITE, 0.15),
        borderBottomWidth: 0,
        borderRadius: 30,
    },
    hoveredContainer: {
        backgroundColor: hexToRgba(ColorEnum.WHITE, 0.0625),
    },
    pressedContainer: {
        backgroundColor: hexToRgba(ColorEnum.WHITE, 0.25),
    },
    iconContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.BRICK_600,
        borderRadius: 22,
        height: 44,
        width: 44,
    },
    title: {
        color: ColorEnum.WHITE,
        fontFamily: FontEnum.SatoshiRegular,
        fontSize: 16,
    },
    subtitle: {
        color: ColorEnum.VIOLET_200,
        fontFamily: FontEnum.SatoshiRegular,
        marginTop: 4,
    },
})

export default IconCard
